import { rootApi } from "../../api/rootApi";

export const notificationRuleApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchNotificationRules: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/notification-v2/fetch-rule`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        addNotificationRule: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/notification-v2/add-rule`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        updateNotificationRuleStatus: builder.mutation({
            query: (params) => {
                return {
                    method: "PUT",
                    url: `/tenant/notification-v2/rule/status/${params.id}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: {
                        active: params.active,
                    },
                };
            },
        }),
    }),
});

export const {
    useFetchNotificationRulesMutation,
    useAddNotificationRuleMutation,
    useUpdateNotificationRuleStatusMutation,
} = notificationRuleApi;
